import { useLang } from '../i18n/context';
import { primaryCommunity } from '../data/communityData';
import './CommunityPage.css';

// DeBox 社群介绍页：苹果式简约 + 黑金调性。先介绍 + 引导，再给 DeBox 注册外链。
const STEP_KEYS = [1, 2, 3];

const SERVICE_ICONS = [
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4.5A1.5 1.5 0 0 1 5.5 3H19a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5.5A1.5 1.5 0 0 1 4 18.5z"/><path d="M4 17h14"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="16 7 21 7 21 12"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5z"/></svg>',
];

function renderJoinLabel(label) {
  const [before, after] = label.split('GHOST');

  if (after === undefined) return label;

  return (
    <>
      {before}
      <span className="community-ghost-word">GHOST</span>
      {after}
    </>
  );
}

function CommunityPage() {
  const { t } = useLang();
  const group = primaryCommunity;
  const openDebox = group.joinUrl;
  const joinLabel = t('community.joinNow');

  return (
    <main className="community-page">
      <section className="community-hero">
        <span className="community-eyebrow">GHOST · COMMUNITY</span>
        <h1>{t('community.heroTitle')}</h1>
        <p className="community-hero-sub">{t('community.heroDesc')}</p>
        <a className="community-cta" href={openDebox} target="_blank" rel="noopener noreferrer">
          {renderJoinLabel(joinLabel)}
        </a>
        <span className="community-hint">{t('community.hint')}</span>
      </section>

      <section className="community-block community-debox-intro" aria-labelledby="community-debox-title">
        <div>
          <h2 id="community-debox-title">{t('community.whatTitle')}</h2>
          <p>{t('community.whatDesc')}</p>
        </div>
        <div className="community-app-mark" aria-label={`${group.name} 社群入口`}>
          <img src={group.logo} alt={`${group.name} logo`} />
        </div>
      </section>

      <section className="community-block community-services">
        <h2>{t('community.servicesTitle')}</h2>
        <p>{t('community.servicesDesc')}</p>
        <div className="community-services-grid">
          {STEP_KEYS.map((n) => (
            <article className="community-service-card" key={n}>
              <span
                className="community-service-icon"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: SERVICE_ICONS[n - 1] }}
              />
              <h3>{t(`community.service${n}Title`)}</h3>
              <p>{t(`community.service${n}Desc`)}</p>
              <span className="community-service-points">{t(`community.service${n}Points`)}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="community-block community-steps">
        <h2>{t('community.stepsTitle')}</h2>
        <ol>
          {STEP_KEYS.map((n) => (
            <li key={n}>
              <span className="community-step-num">0{n}</span>
              <div>
                <h3>{t(`community.step${n}Title`)}</h3>
                <p>{t(`community.step${n}Desc`)}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="community-finale">
        <h2>{t('community.finaleTitle')}</h2>
        <a className="community-cta" href={openDebox} target="_blank" rel="noopener noreferrer">
          {renderJoinLabel(joinLabel)} →
        </a>
      </section>
    </main>
  );
}

export default CommunityPage;
